'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/ref.js
// module id = 1226
// module chunks = 5